export const MentorshipEndpoints = {
    getMentorship: (mentorshipId) => {
        return `${process.env.API_CLUB_CONTENT}/v4/modules/mentorships/${mentorshipId}`;
    },
    createMentorship: () => {
        return `${process.env.API_CLUB_CONTENT}/v4/modules/mentorships`;
    },
    updateMentorship: (mentorshipId) => {
        return `${process.env.API_CLUB_CONTENT}/v4/modules/mentorships/${mentorshipId}`;
    }
};
export const UserProfileEndpoints = {
    getUser: () => {
        return `${process.env.API_MARKETPLACE}/userprofile/rest/v1/user?onlySupportedLocales=true`;
    }
};
